import styled from 'styled-components';
import { Navigation } from '@studio/navigation';
import { Icon } from '@appcues/sonar';

export const AssistantButton = styled(Navigation.ButtonItem)`
  gap: var(--spacing-x-small);

  ${Icon} {
    margin-right: var(--spacing-x-small);
    margin-left: var(--spacing-small);
  }
`;
